/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_Remove_GroupInputs */

const en_task_flow_remove_group = /** @type {(inputs: Task_Flow_Remove_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove group`)
};

const pt_br2_task_flow_remove_group = /** @type {(inputs: Task_Flow_Remove_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover grupo`)
};

/**
* | output |
* | --- |
* | "Remove group" |
*
* @param {Task_Flow_Remove_GroupInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_remove_group = /** @type {((inputs?: Task_Flow_Remove_GroupInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_Remove_GroupInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_remove_group(inputs)
	return pt_br2_task_flow_remove_group(inputs)
});